import React, { useEffect, useState } from 'react'
import { DataProvider, PosPage, NavBar } from '../../components-pos'
import { FooterBar } from '../../components-pos/Layout'
import { posDisplaySize } from '../../settings'
// import { Auth } from 'aws-amplify'
// import { attachPolicy } from '../../../../lib/pay-api-lib'
// import { subscribe, publish } from '../../../../lib/pubsubLib'
import SaleMain from './main-section/Sale-Main'
import { OrderSection } from './order-section/Order-Section'
import { debug } from '../../../../settings'
// import { getOrderStatusList } from '../../../../lib/ec2-api-lib'
import {
  // getOnlOrderStatusList,
  // onlposGetOrderStatusList,
  onlposListOrderStatus,
} from '../../lib/api-onlpos'
import { isJson, sortObjArray2 } from '../../../../lib/utils'

export default function SalesIndex(props) {
  return <DataProvider {...props} Component={Index__} />
}

/** @iot_connection OrderStatus_index 참조 */
/**
 * @procedure
 *  1. tableInfoList 생성
 *    1.1 SaleMain > onOrderReceive
 *      -> check orderReceivable
 *      -> if orderReceivable -> update tableInfoList, publish ok response
 *         else reject order
 *  2. table click
 *      -> setVisibleOrderSection true
 *      -> selectedTableInfo
 */
function Index__(props) {
  const { shopInfo } = props
  const [selectedTableInfo, setSelectedTableInfo] = useState(null)

  const [visibleOrderSection, setVisibleOrderSection] = useState(false)
  const [visiblePaySection, setVisiblePaySection] = useState(false)

  const [alarmSound, setAlarm] = useState(null)

  const [orderList, setOrderList] = useState([])

  useEffect(() => {
    const myAudio = new Audio(
      'https://psdl-oneul-storage.s3.ap-northeast-2.amazonaws.com/public/test/alarmSound.mp3',
    )
    setAlarm(myAudio)
  }, [setAlarm])

  useEffect(() => {
    updateOrderList()
  }, [])

  /**
   * @order_record_생성
   *  1. shopId: "ONLPOS-" + shopInfo.shopId
   *  2. orderId: table.tableCode
   *  3. orderData: { orderList, tableCode }
   */

  const updateOrderList = async () => {
    try {
      
      // let res = await onlposGetOrderStatusList({ shopInfo })
      let res = await onlposListOrderStatus({ shopInfo })
      if (res.err) throw Error(res.err.message)

      const newOrderList = res.result.Items.map((item) => {
        return {
          ...item,
          tableCode: item.orderId,
          orderData: isJson(item.orderData) ? JSON.parse(item.orderData) : {},
        }
      })

      const newOrderList2 = sortObjArray2({
        arr: newOrderList,
        key: 'created',
      })
      setOrderList(newOrderList2)

      if (debug) {
        console.log('='.repeat(50), 'orderList', newOrderList.length)
        newOrderList2.map((o) => {
          if (o.orderData?.orderList?.length > 0) {
            console.log(
              '-'.repeat(20),
              `tableCode ${o.orderId}, orderList len = ${o.orderData?.orderList.length}`,
            )
          }
        })
      }
    } catch (e) {
      alert(e.message)
    } finally {
      // setIsLoading(false)
    }
  }

  const audioPlay = () => {
    if (alarmSound?.readyState === 4) alarmSound?.play()
  }

  const pageProps = {
    ...props,
    visibleOrderSection,
    setVisibleOrderSection,
    visiblePaySection,
    setVisiblePaySection,

    selectedTableInfo,
    setSelectedTableInfo,

    audioPlay,

    orderList,
    setOrderList,
    updateOrderList,
    onload: updateOrderList,
  }

  const styles = {
    wrap: {
      // border: '1px solid #ddd',
      width: '100%',
      height: posDisplaySize.width * posDisplaySize.ratio,
      backgroundColor: 'azure',
      display: 'flex',
      flexDirection: 'column',
    },
  }

  return (
    <PosPage>
      <div style={styles.wrap}>
        <NavLinks {...props} />
        <SaleMain {...pageProps} />
        <FooterBar {...props} />
        {visibleOrderSection && <OrderSection {...pageProps} />}
        {/* {visiblePaySection && <PaySection {...pageProps} />} */}
      </div>
    </PosPage>
  )
}

export function NavLinks(props) {
  const links = [
    { name: '매출분석', path: '/pos/analysis' },
    { name: '종합관리', path: '/pos/setting' },
  ]
  return <NavBar {...props} links={links} />
}
